var map = {
	"./SpinGeneral_001.webp": 23200,
	"./SpinGeneral_002.webp": 59514,
	"./SpinGeneral_003.webp": 43916,
	"./SpinGeneral_004.webp": 29524,
	"./SpinGeneral_005.webp": 18354,
	"./SpinGeneral_006.webp": 78506,
	"./SpinGeneral_007.webp": 28862,
	"./SpinGeneral_008.webp": 94155,
	"./SpinGeneral_009.webp": 16928,
	"./SpinGeneral_010.webp": 60390,
	"./SpinGeneral_011.webp": 51321,
	"./SpinGeneral_012.webp": 51763,
	"./SpinGeneral_013.webp": 32643,
	"./SpinGeneral_014.webp": 26611,
	"./SpinGeneral_015.webp": 56303,
	"./SpinGeneral_016.webp": 89453,
	"./SpinGeneral_017.webp": 42870,
	"./SpinGeneral_018.webp": 51943,
	"./SpinGeneral_019.webp": 93092,
	"./SpinGeneral_020.webp": 74181,
	"./SpinGeneral_021.webp": 75758,
	"./SpinGeneral_022.webp": 30196,
	"./SpinGeneral_023.webp": 97673,
	"./SpinGeneral_024.webp": 84410,
	"./SpinGeneral_025.webp": 20029,
	"./SpinGeneral_026.webp": 56866,
	"./SpinGeneral_027.webp": 6191,
	"./SpinGeneral_028.webp": 28725,
	"./SpinGeneral_029.webp": 32039,
	"./SpinGeneral_030.webp": 83396,
	"./SpinGeneral_031.webp": 34024,
	"./SpinGeneral_032.webp": 67051,
	"./SpinGeneral_033.webp": 38859,
	"./SpinGeneral_034.webp": 86231,
	"./SpinGeneral_035.webp": 19502,
	"./SpinGeneral_036.webp": 74733,
	"./SpinGeneral_037.webp": 33861,
	"./SpinGeneral_038.webp": 29322,
	"./SpinGeneral_039.webp": 65159,
	"./SpinGeneral_040.webp": 77256,
	"./SpinGeneral_041.webp": 60419,
	"./SpinGeneral_042.webp": 79402,
	"./SpinGeneral_043.webp": 73933,
	"./SpinGeneral_044.webp": 28230,
	"./SpinGeneral_045.webp": 96174,
	"./SpinGeneral_046.webp": 34446,
	"./SpinGeneral_047.webp": 48435,
	"./SpinGeneral_048.webp": 61669,
	"./SpinGeneral_049.webp": 25866,
	"./SpinGeneral_050.webp": 5094,
	"./SpinGeneral_051.webp": 86636,
	"./SpinGeneral_052.webp": 69298,
	"./SpinGeneral_053.webp": 51195,
	"./SpinGeneral_054.webp": 94727,
	"./SpinGeneral_055.webp": 24172,
	"./SpinGeneral_056.webp": 98075,
	"./SpinGeneral_057.webp": 71795,
	"./SpinGeneral_058.webp": 1244,
	"./SpinGeneral_059.webp": 19473,
	"./SpinGeneral_060.webp": 68515,
	"./SpinGeneral_061.webp": 71734,
	"./SpinGeneral_062.webp": 63407,
	"./SpinGeneral_063.webp": 23891,
	"./SpinGeneral_064.webp": 73458,
	"./SpinGeneral_065.webp": 67940,
	"./SpinGeneral_066.webp": 48071,
	"./SpinGeneral_067.webp": 60141,
	"./SpinGeneral_068.webp": 14165,
	"./SpinGeneral_069.webp": 66099,
	"./SpinGeneral_070.webp": 75690,
	"./SpinGeneral_071.webp": 43482,
	"./SpinGeneral_072.webp": 65481
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86132;